import withMediaQuery from './withMediaQuery';
import { TABLET } from '../../style/common/breakpoints';

export default function withMatchesTablet(Component) {
  return withMediaQuery(TABLET)(Component);
}
